import PropTypes from 'prop-types';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import CaseMetricsArtifactHitCountModalContainer
  from './../Containers/CaseMetricsArtifactHitCountModalContainer';
import ConditionalComponent from './ConditionalComponent';

const getHitCountText = (isCcf, hitCount) => {
  const type = `${isCcf ? 'C' : 'N'}CF`;
  const hits = `${hitCount > 0 ? '+' : ''}${hitCount}`;
  return `View ${type} Diffs: ${hits}`;
};

const EngineMetricsDeltasComponent = ({
  primaryName,
  secondaryName,
  ccfHitDelta,
  ncfHitDelta,
  sourceDelta,
  sourceAttributeDelta,
  onLinkClick
}) => (
  <ConditionalComponent condition={(primaryName || secondaryName) !== undefined}>
    <CaseMetricsArtifactHitCountModalContainer />
    <Row>
      <fieldset>
        <legend>
          Deltas: {`${primaryName ? primaryName : 'None Selected'} --\
            ${secondaryName ? secondaryName + ' (Baseline)' : 'None Selected'}`}
        </legend>
      </fieldset>
    </Row>
    <Row>
      <Col md={4}><b>Source Counts</b></Col>
      <Col md={4}><b>Hit Count Differences</b></Col>
    </Row>
    <Row>
      <Col md={2}>Source Count: {sourceDelta} </Col>
      <Col md={2}>Attribute Count: {sourceAttributeDelta} </Col>
      <Col md={2}>
        <Button
          bsSize={'small'}
          id={'ccf-diff-button'}
          onClick={() => onLinkClick(true)}
        >
          {getHitCountText(true, ccfHitDelta)}
        </Button>
      </Col>
      <Col md={2}>
        <Button
          bsSize={'small'}
          id={'ncf-diff-button'}
          onClick={() => onLinkClick(false)}
        >
          {getHitCountText(false, ncfHitDelta)}
        </Button>
      </Col>
    </Row>
  </ConditionalComponent>
);

EngineMetricsDeltasComponent.propTypes = {
  primaryName: PropTypes.string,
  secondaryName: PropTypes.string,
  ccfHitDelta: PropTypes.number.isRequired,
  ncfHitDelta: PropTypes.number.isRequired,
  sourceDelta: PropTypes.number.isRequired,
  sourceAttributeDelta: PropTypes.number.isRequired,
  onLinkClick: PropTypes.func.isRequired
};

export default EngineMetricsDeltasComponent;


// WEBPACK FOOTER //
// src/Components/EngineMetricsDeltasComponent.jsx